import { ADD_OPHOUSE_LEAD_FAIL, ADD_OPHOUSE_LEAD_SUCCESS, CREATE_CLIENT_APPOINTMENT_FAIL, CREATE_CLIENT_APPOINTMENT_SUCCESS, CREATE_CLIENT_BUYER_CLOSING_FAIL, CREATE_CLIENT_BUYER_CLOSING_SUCCESS, CREATE_CLIENT_BUYER_PREF_FAIL, CREATE_CLIENT_BUYER_PREF_SUCCESS, CREATE_CLIENT_CHILD_FAIL, CREATE_CLIENT_CHILD_SUCCESS, CREATE_CLIENT_DOCUMENT, CREATE_CLIENT_DOCUMENT_FAIL, CREATE_CLIENT_DOCUMENT_SUCCESS, CREATE_CLIENT_IMPORTANT_DATE_FAIL, CREATE_CLIENT_IMPORTANT_DATE_SUCCESS, CREATE_CLIENT_MESSAGE_FAIL, CREATE_CLIENT_MESSAGE_SUCCESS, CREATE_CLIENT_NOTE_FAIL, CREATE_CLIENT_NOTE_SUCCESS, CREATE_CLIENT_SELLER_CLOSING_FAIL, CREATE_CLIENT_SELLER_CLOSING_SUCCESS, CREATE_CLIENT_SELLER_LISTING_FAIL, CREATE_CLIENT_SELLER_LISTING_SUCCESS, CREATE_CLIENT_SELLER_OPHOUSE, CREATE_CLIENT_SELLER_OPHOUSE_FAIL, CREATE_CLIENT_SELLER_OPHOUSE_SUCCESS, CREATE_CLIENT_SELLER_PREFERENCE_FAIL, CREATE_CLIENT_SELLER_PREFERENCE_SUCCESS, CREATE_CLIENT_SELLER_SHOWING_FAIL, CREATE_CLIENT_SELLER_SHOWING_SUCCESS, CREATE_NEW_CLIENT_FAIL, CREATE_NEW_CLIENT_SUCCESS, DELETE_CLIENT_ADD_LISTING_FAIL, DELETE_CLIENT_ADD_LISTING_SUCCESS, DELETE_CLIENT_APPOINTMENT_FAIL, DELETE_CLIENT_APPOINTMENT_SUCCESS, DELETE_CLIENT_BUYER_CLOSING_FAIL, DELETE_CLIENT_BUYER_CLOSING_SUCCESS, DELETE_CLIENT_DOCUMENT_FAIL, DELETE_CLIENT_DOCUMENT_SUCCESS, DELETE_CLIENT_IMPORTANT_DATE_FAIL, DELETE_CLIENT_IMPORTANT_DATE_SUCCESS, DELETE_CLIENT_NOTE_FAIL, DELETE_CLIENT_NOTE_SUCCESS, DELETE_CLIENT_OPENHOUSE_FAIL, DELETE_CLIENT_OPENHOUSE_SUCCESS, DELETE_CLIENT_SELLER_CLOSING_FAIL, DELETE_CLIENT_SELLER_CLOSING_SUCCESS, DELETE_CLIENT_SELLER_LISTING_FAIL, DELETE_CLIENT_SELLER_LISTING_SUCCESS, DELETE_CLIENT_SELLER_SHOWING_FAIL, DELETE_CLIENT_SELLER_SHOWING_SUCCESS, GET_CLIENTS, GET_CLIENTS_APPOINTMENT, GET_CLIENTS_APPOINTMENT_FAIL, GET_CLIENTS_APPOINTMENT_SUCCESS, GET_CLIENTS_DETAIL, GET_CLIENTS_DETAIL_FAIL, GET_CLIENTS_DETAIL_SUCCESS, GET_CLIENTS_DOCUMENT, GET_CLIENTS_DOCUMENT_FAIL, GET_CLIENTS_DOCUMENT_SUCCESS, GET_CLIENTS_FAIL, GET_CLIENTS_MESSAGE, GET_CLIENTS_MESSAGE_FAIL, GET_CLIENTS_MESSAGE_SUCCESS, GET_CLIENTS_NOTE, GET_CLIENTS_NOTE_FAIL, GET_CLIENTS_NOTE_SUCCESS, GET_CLIENTS_SELLER_CLOSING, GET_CLIENTS_SELLER_CLOSING_FAIL, GET_CLIENTS_SELLER_CLOSING_SUCCESS, GET_CLIENTS_SELLER_LISTING, GET_CLIENTS_SELLER_LISTING_FAIL, GET_CLIENTS_SELLER_LISTING_SUCCESS, GET_CLIENTS_SELLER_SHOWING, GET_CLIENTS_SELLER_SHOWING_FAIL, GET_CLIENTS_SELLER_SHOWING_SUCCESS, GET_CLIENTS_SUCCESS, GET_CLIENT_ADD_LISTING, GET_CLIENT_ADD_LISTING_FAIL, GET_CLIENT_ADD_LISTING_SUCCESS, GET_CLIENT_BUYER_CLOSING, GET_CLIENT_BUYER_CLOSING_FAIL, GET_CLIENT_BUYER_CLOSING_SUCCESS, GET_CLIENT_CHILD_FAIL, GET_CLIENT_CHILD_SUCCESS, GET_CLIENT_IMPORTANT_DATE_FAIL, GET_CLIENT_IMPORTANT_DATE_SUCCESS, GET_CLIENT_RECENT_ACTIVITIES_FAIL, GET_CLIENT_RECENT_ACTIVITIES_SUCCESS, GET_CLIENT_SELLER_OPHOUSE_FAIL, GET_CLIENT_SELLER_OPHOUSE_SUCCESS, GET_CLIENT_UPCOMING_ACTIVITIES_FAIL, GET_CLIENT_UPCOMING_ACTIVITIES_SUCCESS, UPDATE_CLIENT_ADD_LISTING_FAIL, UPDATE_CLIENT_ADD_LISTING_SUCCESS, UPDATE_CLIENT_APPOINTMENT_FAIL, UPDATE_CLIENT_APPOINTMENT_SUCCESS, UPDATE_CLIENT_BUYER_CLOSING_FAIL, UPDATE_CLIENT_BUYER_CLOSING_SUCCESS, UPDATE_CLIENT_DOCUMENT_FAIL, UPDATE_CLIENT_DOCUMENT_SUCCESS, UPDATE_CLIENT_NOTE_FAIL, UPDATE_CLIENT_NOTE_SUCCESS, UPDATE_CLIENT_OPENHOUSE_FAIL, UPDATE_CLIENT_OPENHOUSE_SUCCESS, UPDATE_CLIENT_PROFILE_FAIL, UPDATE_CLIENT_PROFILE_SUCCESS, UPDATE_CLIENT_SELLER_CLOSING_FAIL, UPDATE_CLIENT_SELLER_CLOSING_SUCCESS, UPDATE_CLIENT_SELLER_LISTING_FAIL, UPDATE_CLIENT_SELLER_LISTING_SUCCESS, UPDATE_CLIENT_SELLER_SHOWING_FAIL, UPDATE_CLIENT_SELLER_SHOWING_SUCCESS } from "./actionTypes"

const initialState = {

  error: "",
  loading: true,
  clientLists: [],
  clietDetail: '',
  messages: [],
  documents: [],
  appointments: [],
  notes: [],
  showings: [],
  closings: [],
  listings: [],
  ophouses: [],
  addListings: [],
  uactivities: [],
  ractivities: [],
  importantdates: [],
  childs: [],
  buyerClosings: []

}

const Clients = (state = initialState, action) => {
  switch (action.type) {

    case GET_CLIENTS:
      return {
        ...state,
        loading: true,
      }
    case GET_CLIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        clientLists: action.payload,
      }
    case GET_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CLIENTS_DETAIL:
      return {
        ...state,
        loading: true,
      }
    case GET_CLIENTS_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        clietDetail: action.payload,
      }
    case GET_CLIENTS_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload
      }
    case CREATE_CLIENT_MESSAGE_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_MESSAGE_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
      case GET_CLIENTS_MESSAGE:
        return {
          ...state,
          loading: true,
        }
    case GET_CLIENTS_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: action.payload,
        loading: false
      }
    case GET_CLIENTS_MESSAGE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      
    case CREATE_CLIENT_DOCUMENT_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_DOCUMENT_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
      case GET_CLIENTS_DOCUMENT:
        return {
          ...state,
          loading: true,
        }
    case GET_CLIENTS_DOCUMENT_SUCCESS:
      return {
        ...state,
        documents: action.payload,
        loading: false,
      }
    case GET_CLIENTS_DOCUMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CREATE_CLIENT_APPOINTMENT_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_APPOINTMENT_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
      case GET_CLIENTS_APPOINTMENT:
        return {
          ...state,
          loading: true,
        }
    case GET_CLIENTS_APPOINTMENT_SUCCESS:
      return {
        ...state,
        appointments: action.payload,
        loading: false,
      }
    case GET_CLIENTS_APPOINTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CREATE_CLIENT_NOTE_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_NOTE_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
      case GET_CLIENTS_NOTE:
        return {
          ...state,
          loading:true
        }
    case GET_CLIENTS_NOTE_SUCCESS:
      return {
        ...state,
        notes: action.payload,
        loading:false
      }
    case GET_CLIENTS_NOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CREATE_CLIENT_SELLER_SHOWING_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_SELLER_SHOWING_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
      case GET_CLIENTS_SELLER_SHOWING:
        return {
          ...state,
          loading: true
        }
    case GET_CLIENTS_SELLER_SHOWING_SUCCESS:
      return {
        ...state,
        showings: action.payload,
        loading: false
      }
    case GET_CLIENTS_SELLER_SHOWING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CREATE_CLIENT_SELLER_CLOSING_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_SELLER_CLOSING_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
      case GET_CLIENTS_SELLER_CLOSING:
        return {
          ...state,
          loading: true,
        }
    case GET_CLIENTS_SELLER_CLOSING_SUCCESS:
      return {
        ...state,
        closings: action.payload,
        loading: false
      }
    case GET_CLIENTS_SELLER_CLOSING_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CREATE_CLIENT_SELLER_LISTING_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_SELLER_LISTING_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
    case UPDATE_CLIENT_SELLER_LISTING_SUCCESS:
      return {
        ...state,
        listings: state.listings.map(listing =>
          listing.id.toString() === action.payload.id.toString()
            ? { listing, ...action.payload }
            : listing
        ),
      }

    case UPDATE_CLIENT_SELLER_LISTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_SELLER_LISTING_SUCCESS:
      return {
        ...state,
        listing: action.payload,
      }

    case DELETE_CLIENT_SELLER_LISTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    
      case GET_CLIENTS_SELLER_LISTING:
        return {
          ...state,
          loading: true
        }
    case GET_CLIENTS_SELLER_LISTING_SUCCESS:
      return {
        ...state,
        listings: action.payload,
        loading: false
      }
    case GET_CLIENTS_SELLER_LISTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CREATE_CLIENT_SELLER_OPHOUSE_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_SELLER_OPHOUSE_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CLIENT_SELLER_OPHOUSE_SUCCESS:
      return {
        ...state,
        ophouses: action.payload,
      }
    case GET_CLIENT_SELLER_OPHOUSE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_OPHOUSE_LEAD_SUCCESS:

      state = {
        ...state,
        loading: false,
      }
      break
    case ADD_OPHOUSE_LEAD_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
    case CREATE_CLIENT_SELLER_PREFERENCE_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_SELLER_PREFERENCE_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
      case GET_CLIENT_ADD_LISTING:
        return {
          ...state,
          loading: true
        }
    case GET_CLIENT_ADD_LISTING_SUCCESS:
      return {
        ...state,
        addListings: action.payload,
        loading:false
      }
    case GET_CLIENT_ADD_LISTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CLIENT_ADD_LISTING_SUCCESS:
      return {
        ...state,
        addListings: state.addListings.map(addListing =>
          addListing.id.toString() === action.payload.id.toString()
            ? { addListing, ...action.payload }
            : addListing
        ),
      }

    case UPDATE_CLIENT_ADD_LISTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_ADD_LISTING_SUCCESS:
      return {
        ...state,
        addListing: action.payload,
      }

    case DELETE_CLIENT_ADD_LISTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_DOCUMENT_SUCCESS:
      return {
        ...state,
        document: action.payload,
      }

    case DELETE_CLIENT_DOCUMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_APPOINTMENT_SUCCESS:
      return {
        ...state,
        appointment: action.payload,
      }

    case DELETE_CLIENT_APPOINTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CLIENT_APPOINTMENT_SUCCESS:
      return {
        ...state,
        appointments: state.appointments.map(appointment =>
          appointment.id.toString() === action.payload.id.toString()
            ? { appointment, ...action.payload }
            : appointment
        ),
      }

    case UPDATE_CLIENT_APPOINTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_CLIENT_DOCUMENT_SUCCESS:
      return {
        ...state,
        documents: state.documents.map(document =>
          document.id.toString() === action.payload.id.toString()
            ? { document, ...action.payload }
            : document
        ),
      }

    case UPDATE_CLIENT_DOCUMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_NOTE_SUCCESS:
      return {
        ...state,
        note: action.payload,
      }

    case DELETE_CLIENT_NOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CLIENT_NOTE_SUCCESS:
      return {
        ...state,
        notes: state.documents.map(note =>
          note.id.toString() === action.payload.id.toString()
            ? { note, ...action.payload }
            : note
        ),
      }

    case UPDATE_CLIENT_NOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_OPENHOUSE_SUCCESS:
      return {
        ...state,
        openhouse: action.payload,
      }

    case DELETE_CLIENT_OPENHOUSE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CLIENT_OPENHOUSE_SUCCESS:
      return {
        ...state,
        ophouses: state.ophouses.map(ophouse =>
          ophouse.id.toString() === action.payload.id.toString()
            ? { ophouse, ...action.payload }
            : ophouse
        ),
      }

    case UPDATE_CLIENT_OPENHOUSE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CLIENT_SELLER_SHOWING_SUCCESS:
      return {
        ...state,
        showings: state.showings.map(showing =>
          showing.id.toString() === action.payload.id.toString()
            ? { showing, ...action.payload }
            : showing
        ),
      }

    case UPDATE_CLIENT_SELLER_SHOWING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_SELLER_SHOWING_SUCCESS:
      return {
        ...state,
        showing: action.payload,
      }

    case DELETE_CLIENT_SELLER_SHOWING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CLIENT_SELLER_CLOSING_SUCCESS:
      return {
        ...state,
        closings: state.closings.map(closing =>
          closing.id.toString() === action.payload.id.toString()
            ? { closing, ...action.payload }
            : closing
        ),
      }

    case UPDATE_CLIENT_SELLER_CLOSING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_SELLER_CLOSING_SUCCESS:
      return {
        ...state,
        closing: action.payload,
      }

    case DELETE_CLIENT_SELLER_CLOSING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CREATE_CLIENT_BUYER_PREF_SUCCESS:

      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_BUYER_PREF_FAIL:

      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CLIENT_UPCOMING_ACTIVITIES_SUCCESS:
      return {
        ...state,
        uactivities: action.payload,
      }
    case GET_CLIENT_UPCOMING_ACTIVITIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CLIENT_RECENT_ACTIVITIES_SUCCESS:
      return {
        ...state,
        ractivities: action.payload,
      }
    case GET_CLIENT_RECENT_ACTIVITIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CREATE_CLIENT_IMPORTANT_DATE_SUCCESS:

      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_IMPORTANT_DATE_FAIL:

      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CLIENT_IMPORTANT_DATE_SUCCESS:
      return {
        ...state,
        importantdates: action.payload,
      }
    case GET_CLIENT_IMPORTANT_DATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CREATE_CLIENT_CHILD_SUCCESS:

      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_CHILD_FAIL:

      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CLIENT_CHILD_SUCCESS:
      return {
        ...state,
        childs: action.payload,
      }
    case GET_CLIENT_CHILD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_IMPORTANT_DATE_SUCCESS:
      return {
        ...state,
        importantdate: action.payload,
      }

    case DELETE_CLIENT_IMPORTANT_DATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CLIENT_PROFILE_SUCCESS:
      return {
        ...state,
        clietDetail: action.payload,
      }

    case UPDATE_CLIENT_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CREATE_NEW_CLIENT_SUCCESS:

      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_NEW_CLIENT_FAIL:

      state = { ...state, error: action.payload, loading: false }
      break
    case CREATE_CLIENT_BUYER_CLOSING_SUCCESS:

      state = {
        ...state,
        loading: false,
      }
      break
    case CREATE_CLIENT_BUYER_CLOSING_FAIL:

      state = { ...state, error: action.payload, loading: false }
      break
      case GET_CLIENT_BUYER_CLOSING:
        return {
          ...state,
          loading: true
        }
    case GET_CLIENT_BUYER_CLOSING_SUCCESS:
      return {
        ...state,
        buyerClosings: action.payload,
        loading: false
      }
    case GET_CLIENT_BUYER_CLOSING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLIENT_BUYER_CLOSING_SUCCESS:
      return {
        ...state,
        buyerClosing: action.payload,
      }

    case DELETE_CLIENT_BUYER_CLOSING_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_CLIENT_BUYER_CLOSING_SUCCESS:
      return {
        ...state,
        buyerClosings: state.buyerClosings.map(buyerClosing =>
          buyerClosing.id.toString() === action.payload.id.toString()
            ? { buyerClosing, ...action.payload }
            : buyerClosing
        ),
      }

    case UPDATE_CLIENT_BUYER_CLOSING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      state = { ...state }
      break

  }
  return state
}

export default Clients
